module.exports = __webpack_public_path__ + "static/media/mv03.0794b7de.jpg";